import { WarningIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useDisclosure,
  VStack
} from '@chakra-ui/react';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loading } from '../../components/widgets/Loading';
import {
  getQuizQuestions,
  sendQuizAnswers
} from '../../services/previdencia-individual/consentimento.service';
import SVGLogo from './logo_sulamerica.svg';

export const QuizLGPD = (): JSX.Element => {
  const { nomeBeneficiario = '' } = JSON.parse(
    sessionStorage.getItem('consentimento') || '{}'
  );
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [chancesToAnswer, setChancesToAnswer] = useState(3);
  const [radioQuestion1, setRadioQuestion1] = useState('');
  const [radioQuestion2, setRadioQuestion2] = useState('');
  const [radioQuestion3, setRadioQuestion3] = useState('');
  const [radioQuestion4, setRadioQuestion4] = useState('');
  const [quizKey, setQuizKey] = useState('');
  const [showModalCloseButton, setShowModalCloseButton] = useState(true);
  const [modalMessage, setModalMessage] = useState('');
  const [greetingText, setGreetingText] = useState(
    `Olá ${nomeBeneficiario}, preencha o questionário abaixo para continuar:`
  );
  const [questions, setQuestions] = useState([
    {
      title: '',
      answers: ['']
    }
  ]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const windowWidth = window.innerWidth;
  const navigate = useNavigate();

  useEffect(() => {
    //get from API
    //setLoading(true);
    getQuiz();
  }, []);

  useEffect(() => {
    if (
      radioQuestion1 != '' &&
      radioQuestion2 != '' &&
      radioQuestion3 != '' &&
      radioQuestion4 != ''
    )
      setDisable(false);
    else setDisable(true);
  }, [radioQuestion1, radioQuestion2, radioQuestion3, radioQuestion4]);

  const { isLoading: isLoadingQuestions, refetch: getQuiz } = useQuery({
    queryFn: getQuizQuestions,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    onSuccess: (data) => {
      console.log(data);
      if (
        data.msg_infos &&
        data.msg_infos[0].status === 'UNAUTHORIZED_RESPONSE_INFO'
      ) {
        setShowModalCloseButton(false);
        setModalMessage(
          'Número de tentativas de respostas excedido, por favor contate o seu corretor.'
        );
        setGreetingText('');
        onOpen();
        return;
      }
      setQuizKey(data.quiz_key);
      setQuestions(data.questions);
      setLoading(false);
    },
    onError: (err: any) => {
      console.log('erro ao carregar quiz:', err.message);
    }
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: (data: any) => sendQuizAnswers(data, quizKey),
    onSuccess: ({ status, quizAnsweredCount }) => {
      console.log({ status, quizAnsweredCount });
      if (status === 'UNAUTHORIZED_RESPONSE_INFO') {
        setShowModalCloseButton(false);
        setModalMessage(
          'Encontramos divergências em suas respostas, contate o seu corretor.'
        );
        onOpen();
      } else if (status === 'incorrect') {
        onOpen();
        setChancesToAnswer(3 - quizAnsweredCount);
      } else {
        navigate('/consentimento/accept-term');
      }
    },
    onError: (err) => console.log(err)
  });

  const setRadio = (idx: number, value: string) => {
    if (idx == 0) setRadioQuestion1(value);
    if (idx == 1) setRadioQuestion2(value);
    if (idx == 2) setRadioQuestion3(value);
    if (idx == 3) setRadioQuestion4(value);
  };

  const getCurrentRadio = (idx: number) => {
    if (idx == 0) return radioQuestion1;
    if (idx == 1) return radioQuestion2;
    if (idx == 2) return radioQuestion3;
    return radioQuestion4;
  };

  const handleSubmit = async () => {
    const data = [
      {
        value: radioQuestion1,
        timer: '1'
      },
      {
        value: radioQuestion2,
        timer: '1'
      },
      {
        value: radioQuestion3,
        timer: '1'
      },
      {
        value: radioQuestion4,
        timer: '1'
      }
    ];

    //const res = await axios.post(url, data, axiosConfig);
    mutate(data);
    /* if (chancesToAnswer < 1) {
      setShowModalCloseButton(false);
      setModalMessage('Número de tentativas excedidas');
      onOpen();
    } else if (res.data?.status == 'incorrect') {
      onOpen();
      setChancesToAnswer(chancesToAnswer - 1);
    } else {
      window.location.pathname = '/consentimento/term';
    } */
  };

  const onCloseModal = () => {
    setRadioQuestion1('');
    setRadioQuestion2('');
    setRadioQuestion3('');
    setRadioQuestion4('');
    onClose();
    setLoading(true);
    getQuiz();
  };

  function ErrorModal({ closeButton }: { closeButton: boolean }) {
    const title = showModalCloseButton ? `Respostas incorretas!` : 'Erro';
    const text = showModalCloseButton
      ? `Tente novamente. Você tem mais ${chancesToAnswer} tentativas.`
      : modalMessage;
    return (
      <>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={onCloseModal}
        >
          <ModalOverlay />
          <ModalContent padding={'15px'} width="auto">
            <ModalHeader alignSelf={'center'} fontSize={'19px'} color="red.500">
              <WarningIcon
                style={{ marginRight: '10px' }}
                w={8}
                h={8}
                color="red.500"
              />{' '}
              {title}
            </ModalHeader>
            <ModalBody
              alignSelf={'center'}
              textAlign="center"
              fontSize={'18px'}
            >
              {text}
            </ModalBody>
            <ModalFooter>
              {closeButton && (
                <Button
                  borderRadius="133.5px"
                  borderColor={'black'}
                  border={'1px solid #000000'}
                  width="100%"
                  background="#FFFFFF"
                  onClick={onCloseModal}
                >
                  Close
                </Button>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  if (isLoadingQuestions)
    return (
      <Box
        position={'absolute'}
        top={0}
        left={0}
        w="100vw"
        h={'100vh'}
        display="flex"
        bg={'white'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box>
          <Image
            src={SVGLogo}
            width={256}
            height={256}
            className="svg-elem-1"
          />
          <Progress size="xs" isIndeterminate />
        </Box>
      </Box>
    );

  return (
    <>
      {loading ? (
        <Loading>
          <Text>Carregando...</Text>
        </Loading>
      ) : (
        <Box
          w="100%"
          p={['30px 16px', '30px 16px', '30px 50px']}
          bg="#F5F5F5"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <div
            style={{
              marginRight: 'auto'
            }}
          >
            <p style={{ fontSize: '18px' }}>{greetingText}</p>
          </div>
          <ErrorModal closeButton={showModalCloseButton} />
          {questions?.map((question, idx) => {
            return (
              <VStack
                key={idx}
                w="100%"
                m="15px !important"
                bg="#FFFFFF"
                boxShadow="0px 0px 9px 5px #0000000a"
                borderRadius="12px"
                alignItems={'left'}
              >
                <p
                  style={{
                    fontSize: '18px',
                    padding: '22px 25px 10px 25px',
                    textAlign: 'justify',
                    display: 'inline',
                    textOverflow: 'ellipsis',
                    wordWrap: 'break-word',
                    fontWeight: 'bold'
                  }}
                >
                  {question.title}
                </p>
                <hr></hr>
                <RadioGroup
                  onChange={(e) => {
                    setRadio(idx, e);
                  }}
                  value={getCurrentRadio(idx)}
                  padding={'18px 18px 33px 25px'}
                >
                  <Stack direction="column">
                    {question?.answers?.map((answer, answeridx) => {
                      return (
                        <Radio
                          value={answer}
                          key={answeridx}
                          colorScheme="orange"
                          borderColor={'#FD6520'}
                          pb="10px"
                        >
                          <p
                            style={{
                              fontSize: '16px',
                              padding: '0px 18px 0px 0px',
                              textAlign: 'justify',
                              display: 'inline',
                              width: '100%',
                              wordWrap: 'break-word',
                              wordBreak: 'break-word'
                            }}
                          >
                            {answer}
                          </p>
                        </Radio>
                      );
                    })}
                  </Stack>
                </RadioGroup>
              </VStack>
            );
          })}
          <div
            style={{
              marginLeft: windowWidth > 700 ? 'auto' : 'none',
              width: windowWidth > 700 ? '' : '100%',
              paddingTop: '10px'
            }}
          >
            <Button
              justifyContent="center"
              w={['100%', '100%', '200px']}
              bg={`#FF5000`}
              m="0 !important"
              h="48px"
              p="13px 47px"
              gap="10px"
              borderRadius="133.5px"
              color="#FFFFFF"
              fontWeight="700"
              fontSize="1rem"
              lineHeight="1.375rem"
              textAlign="center"
              alignSelf={'right'}
              isLoading={isLoading}
              loadingText="Enviando..."
              onClick={() => {
                handleSubmit();
              }}
              disabled={disable}
              _disabled={{
                bg: '#D2D2D2'
              }}
              _hover={
                disable
                  ? {}
                  : {
                      WebkitFilter: ' brightness(60%)',
                      transition: 'all 0.4s',
                      WebkitTransition: 'all 0.4s'
                    }
              }
              cursor={disable ? 'not-allowed' : ''}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
            >
              {'Enviar Respostas'}
            </Button>
          </div>
        </Box>
      )}
    </>
  );
};
